import { Field } from "formik";


const IntakeInsuranceInvestigationPersonalAutoUmbrellaAdditionalInformationFields = ({ errors, touched, nested }) => {
    return (
        <div className="form-wrapper general-information">
            <div className="form-field-wrapper insurance-additional-information">
                <label className="left-justified" htmlFor="defendantProofOfInsuranceCard">Do you have the defendant’s Proof of Insurance card? <span className="required">*</span></label>
                <div role="group" aria-labelledby="defendantProofOfInsuranceCard-radio-group" className="form-check-inline left-justified">
                    <div className="form-check">
                        <Field type="radio" name={nested ? "insuranceInvestigationPersonalAutoUmbrellaAdditionalInformation.defendantProofOfInsuranceCard" : "defendantProofOfInsuranceCard"} value="Yes" id="defendantProofOfInsuranceCard-Yes" />
                        <label htmlFor="defendantProofOfInsuranceCard-Yes">Yes</label>
                    </div>
                    <div className="form-check">
                        <Field type="radio" name={nested ? "insuranceInvestigationPersonalAutoUmbrellaAdditionalInformation.defendantProofOfInsuranceCard" : "defendantProofOfInsuranceCard"} value="No" id="defendantProofOfInsuranceCard-No" />
                        <label htmlFor="defendantProofOfInsuranceCard-No">No</label>
                    </div>
                </div>

                {errors && errors.defendantProofOfInsuranceCard && touched && touched.defendantProofOfInsuranceCard ? (
                    <div className="form-error">{errors.defendantProofOfInsuranceCard}</div>
                ) : null}
            </div>

            <div className="form-field-wrapper insurance-additional-information">
                <label className="left-justified" htmlFor="defendantDriversLicense">Do you have a defendant's Driver’s License? <span className="required">*</span></label>
                <div role="group" aria-labelledby="defendantDriversLicense-radio-group" className="form-check-inline left-justified">
                    <div className="form-check">
                        <Field type="radio" name={nested ? "insuranceInvestigationPersonalAutoUmbrellaAdditionalInformation.defendantDriversLicense" : "defendantDriversLicense"} value="Yes" id="defendantDriversLicense-Yes" />
                        <label htmlFor="defendantDriversLicense-Yes">Yes</label>
                    </div>
                    <div className="form-check">
                        <Field type="radio" name={nested ? "insuranceInvestigationPersonalAutoUmbrellaAdditionalInformation.defendantDriversLicense" : "defendantDriversLicense"} value="No" id="defendantDriversLicense-No" />
                        <label htmlFor="defendantDriversLicense-No">No</label>
                    </div>
                </div>

                {errors && errors.defendantDriversLicense && touched && touched.defendantDriversLicense ? (
                    <div className="form-error">{errors.defendantDriversLicense}</div>
                ) : null}
            </div>

            <div className="form-field-wrapper insurance-additional-information">
                <label className="left-justified" htmlFor="letterOfAcknowledgement">Do you have a Letter of Acknowledgment (LOA)? <span className="required">*</span></label>
                <div role="group" aria-labelledby="letterOfAcknowledgement-radio-group" className="form-check-inline left-justified">
                    <div className="form-check">
                        <Field type="radio" name={nested ? "insuranceInvestigationPersonalAutoUmbrellaAdditionalInformation.letterOfAcknowledgement" : "letterOfAcknowledgement"} value="Yes" id="letterOfAcknowledgement-Yes" />
                        <label htmlFor="letterOfAcknowledgement-Yes">Yes</label>
                    </div>
                    <div className="form-check">
                        <Field type="radio" name={nested ? "insuranceInvestigationPersonalAutoUmbrellaAdditionalInformation.letterOfAcknowledgement" : "letterOfAcknowledgement"} value="No" id="letterOfAcknowledgement-No" />
                        <label htmlFor="letterOfAcknowledgement-No">No</label>
                    </div>
                </div>

                {errors && errors.letterOfAcknowledgement && touched && touched.letterOfAcknowledgement ? (
                    <div className="form-error">{errors.letterOfAcknowledgement}</div>
                ) : null}
            </div>

            <div className="form-field-wrapper insurance-additional-information">
                <label className="left-justified" htmlFor="trafficCollisionReport">Do you have the Traffic Collision Report (TCR)? <span className="required">*</span></label>
                <div role="group" aria-labelledby="trafficCollisionReport-radio-group" className="form-check-inline left-justified">
                    <div className="form-check">
                        <Field type="radio" name={nested ? "insuranceInvestigationPersonalAutoUmbrellaAdditionalInformation.trafficCollisionReport" : "trafficCollisionReport"} value="Yes" id="trafficCollisionReport-Yes" />
                        <label htmlFor="trafficCollisionReport-Yes">Yes</label>
                    </div>
                    <div className="form-check">
                        <Field type="radio" name={nested ? "insuranceInvestigationPersonalAutoUmbrellaAdditionalInformation.trafficCollisionReport" : "trafficCollisionReport"} value="No" id="trafficCollisionReport-No" />
                        <label htmlFor="trafficCollisionReport-No">No</label>
                    </div>
                </div>

                {errors && errors.trafficCollisionReport && touched && touched.trafficCollisionReport ? (
                    <div className="form-error">{errors.trafficCollisionReport}</div>
                ) : null}
            </div>
        </div>
    );
};

export default IntakeInsuranceInvestigationPersonalAutoUmbrellaAdditionalInformationFields;